import { render } from "./CercaEmpleat.vue?vue&type=template&id=d0a101e0"
import script from "./CercaEmpleat.vue?vue&type=script&lang=js"
export * from "./CercaEmpleat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__